module.exports = __webpack_public_path__ + "img/21.6b2dc530.jpg";